import { ReactNode } from 'react';

interface SidebarSection {
  children: ReactNode;
  label: string;
}

export function SidebarSection({ children, label }: SidebarSection) {
  return (
    <div className="mb-4">
      <h3 className="text-xs uppercase text-gray-400 dark:text-gray-500 font-semibold pl-3">
        <hr
          className="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden w-6 border-gray-200 dark:border-gray-700/60"
          aria-hidden="true"
        />
        <span className="lg:hidden lg:sidebar-expanded:block 2xl:block">{label}</span>
      </h3>
      <ul className="mt-3">{children}</ul>
    </div>
  );
}
